import { DEFAULT_VALUE } from "@/config";
import { YES_OR_NO } from "@/meta/common";

/** 专区合同 — 采购用户展示所需字段（列表 / 搜索接口 / Customer 均可能满足） */
export interface ZoneContractCustomerLabelInput {
    /** 数据库主键；专区合同采购用户下拉第三段展示为「用户ID」 */
    id?: number;
    /** 用户编码，兼容旧接口数据；无数字 id 时兜底展示 */
    code?: string | null;
    applyState?: number;
    institutionName?: string | null;
    realName?: string | null;
    nickName?: string | null;
    mobile?: string | null;
}

/**
 * 采购用户展示：企业名称 | 手机号 | 用户ID。
 * 专区账户 selector 以企业主体为准，因此企业名称不回退个人实名，避免合同采购主体展示口径混乱。
 */
export function formatZoneContractCustomerLabel(c: ZoneContractCustomerLabelInput): string {
    const enterpriseNamed =
        (c.applyState === undefined || c.applyState === null || c.applyState === YES_OR_NO.YES.code) &&
        c.institutionName?.trim();
    const namePart = enterpriseNamed ? c.institutionName!.trim() : DEFAULT_VALUE;
    const mobile = c.mobile?.trim() || DEFAULT_VALUE;
    const userCode = c.code?.trim() ?? "";
    return `${namePart} | ${mobile} | ${userCode}`;
}

/**
 * 专区合同列表等同款展示：无有效用户 code 且无有效 id 时为 {@link DEFAULT_VALUE}，否则为「实名/机构名|手机号|用户编码」。
 * 第三段仅展示 {@link ZoneContractCustomerLabelInput.code}，不用数字 id。
 */
export function displayZoneContractCustomerText(
    customer: Partial<ZoneContractCustomerLabelInput> | null | undefined
): string {
    const codeTrim = customer?.code?.trim() ?? "";
    const idRaw = customer?.id;
    const id = idRaw === undefined || idRaw === null ? NaN : Number(idRaw);
    const idOk = Number.isFinite(id) && id > 0;
    if (!codeTrim && !idOk) return DEFAULT_VALUE;
    return formatZoneContractCustomerLabel({
        id: customer?.id,
        code: customer?.code,
        applyState: customer?.applyState,
        institutionName: customer?.institutionName,
        realName: customer?.realName,
        nickName: customer?.nickName,
        mobile: customer?.mobile
    });
}
